import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { isAdminRole } from "../lib/roles";

const portalHomeFor = (role) => {
  if (isAdminRole(role)) return "/admin/dashboard";
  return "/portal/dashboard";
};

export const ProtectedRoute = ({ children, role, roles }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50 text-slate-500 text-sm">
        Carregando...
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const allowed = roles && roles.length > 0 ? roles : role ? [role] : null;
  if (allowed) {
    // Treat all admin roles equivalently when "admin" is allowed
    const effective = new Set(allowed);
    if (effective.has("admin")) {
      effective.add("diretor_financeiro");
      effective.add("presidente");
    }
    if (!effective.has(user.role)) {
      return <Navigate to={portalHomeFor(user.role)} replace />;
    }
  }

  // Active-status gating for member roles
  if (
    (user.role === "associado" ||
      user.role === "conselheiro" ||
      user.role === "diretor") &&
    user.status !== "ativo"
  ) {
    return <Navigate to="/aguardando-aprovacao" replace />;
  }

  // First-login document onboarding for associates only
  if (
    user.role === "associado" &&
    user.status === "ativo" &&
    !user.onboarding_completed &&
    location.pathname !== "/portal/boas-vindas"
  ) {
    return <Navigate to="/portal/boas-vindas" replace />;
  }
  return children;
};

export default ProtectedRoute;
